export default __webpack_public_path__ + "static/media/036-symbolic.3ff4a004.png";